<div
  class="tab-pane engine__tab-pane fade show active"
  id="holidays"
  role="tabpanel"
  aria-labelledby="holidays-tab"
>
  <form class="search-from" name="holiday">
    <div class="search-form__engine search-form__row">
      <div class="search-form__col">
        <div class="search-form__engine--row">
          <div class="search-form__guests search-form__element p-0">
            <app-engine-control-guests
              (click)="onInputSelection()"
            ></app-engine-control-guests>
          </div>
          <div class="search-form__dest search-form__element pr-0">
            <app-engine-holiday-modal-destinations
              [onlyCustomHoliday]="onlyCustomHoliday | async"
              [onlyNetQuotes]="onlyNetQuotes | async"
              [engineTabType]="engineTabType"
              [defaultDestination]="holidaySearchParams?.destinationList[0]"
              (click)="onInputSelection()"
              (selectedDestination)="onSelectedDestination($event)"
            ></app-engine-holiday-modal-destinations>
          </div>
          <div
            class="search-form__departure search-form__element pr-0"
            [ngClass]="{ disabled: !selectedDestination?.value }"
          >
            <app-engine-holiday-control-airport
              [isB2B$]="isB2B$"
              [onlyCustomHoliday]="onlyCustomHoliday | async"
              [onlyNetQuotes]="onlyNetQuotes | async"
              [defaultAirport]="holidaySearchParams?.departurePlaces"
              (click)="onInputSelection()"
              [selectedDestination]="selectedDestination"
              [engineTabType]="engineTabType"
              (selectedAirport)="onSelectedAirport($event)"
            ></app-engine-holiday-control-airport>
          </div>
          <div
            class="search-form__calendar search-form__element"
            [ngClass]="{ disabled: !selectedAirport?.value }"
          >
            <app-engine-holiday-control-datepicker
              [onlyCustomHoliday]="onlyCustomHoliday | async"
              [onlyNetQuotes]="onlyNetQuotes | async"
              [defaultDate]="
                selectedDateString || holidaySearchParams?.date_from
              "
              (click)="onInputSelection()"
              [selectedDestination]="selectedDestination"
              [selectedAirport]="selectedAirport"
              [engineTabType]="engineTabType"
              (selectedDate)="onSelectedDate($event)"
            ></app-engine-holiday-control-datepicker>
          </div>
        </div>
        <!-- // FIXME: da decommentare non appena è possibile collegare questa sezione con le strutture ritornate da backend -->
        <!-- // TODO: da prevedere un ngif - visibile solo al click su "mostra altre opzioni" -->
        <!--        <div class="search-form__engine&#45;&#45;row search-form__engine&#45;&#45;row__background"> -->
        <!--          <div class="searc-form__element p-0">-->
        <!--            <div class="form-group-custom">-->
        <!--              <label for="inputStrutturaHoliday" class="input-group-zeus__label">Struttura</label>-->
        <!--              <div class="input-group-custom input-group-custom&#45;&#45;icon-prepend input-group-custom&#45;&#45;icon-prepend&#45;&#45;transparent"-->
        <!--                   id="inputStrutturaHoliday-dropdown">-->
        <!--                <input type="text" class="form-control-custom" id="inputStrutturaHoliday" placeholder="Seleziona struttura..."-->
        <!--                       name="struttura"-->
        <!--                       aria-label="Struttura"-->
        <!--                       aria-describedby="basic-addon3">-->
        <!--                <div class="input-group-custom__prepend input-group-custom__prepend&#45;&#45;transparent">-->
        <!--                  <span class="input-group-custom__icon input-group-custom__icon&#45;&#45;transparent" id="basic-addon2">-->
        <!--                    <i class="g-icon-bed"></i>-->
        <!--                  </span>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <button
        [disabled]="
          !selectedDestination?.value ||
          !selectedAirport?.value ||
          !selectedDate?.value
        "
        (click)="searchHoliday()"
        class="search-form__cta btn btn--sm btn--brand-color-03 btn__uppercase mt-3"
      >
        Cerca <i class="icon-search"></i>
      </button>
    </div>
  </form>
</div>
